import jQuery from "jquery";

import "slick-carousel";

jQuery.event.special.click = {
    setup: function (_, ns, handle) { // eslint-disable-line
        this.addEventListener("click", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) { // eslint-disable-line
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) { // eslint-disable-line
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

jQuery.event.special.wheel = {
    setup: function (_, ns, handle) { // eslint-disable-line
        this.addEventListener("wheel", handle, { passive: true });
    }
};

jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) { // eslint-disable-line
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

jQuery(document).ready(function () {
    if (document.documentMode === 10) {
        document.documentElement.className += " ie10";
    } else if (document.documentMode === 11) {
        document.documentElement.className += " ie11";
    }

    jQuery(".menu-toggle").click(function () {
        jQuery("html").toggleClass("nav-open");
    });

    jQuery(".close-icon").on("click touchstart",function () {
        jQuery("html").removeClass("nav-open");
    });

    jQuery(".menu-toggle").click(function () {
        jQuery("body").toggleClass("menu-open");
    });

    jQuery(".overlay").on("click touchstart",function () {
        jQuery("body").removeClass("menu-open");
        jQuery(".header-menu ul li").removeClass("open");
    });

    jQuery(".close-icon").on("click touchstart",function () {
        jQuery("body").removeClass("menu-open");
        jQuery(".header-menu ul li").removeClass("open");
    });

    /* HOME BANNER SLIDER*/
    jQuery(".slider-wrapper").slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplay: true,
        infinite: true,
        arrows: false,
        speed: 1000,
        dots: jQuery(".slider-wrapper .slider-item").length > 1 ? true : false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });

});
